import { useContext, useMemo } from 'react';
import { validSoftPullSortOptions } from '~/constants/srp/SortOption';
import { useIsTradeLoaded } from '~/context/common/TradeContext';
import { useIsLoggedIn } from '~/context/common/UserContext';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useCreditStatus } from '~/context/srp/FinanceContext/FinanceContext';

export default function useIsRequiredInventoryDataAvailable() {
  const { sortBy } = useContext(AppliedFiltersContext);
  const { isLoaded: isCreditStatusLoaded } = useCreditStatus();
  const isLoggedIn = useIsLoggedIn();
  const isTradeLoaded = useIsTradeLoaded();

  const shouldAwaitCreditStatus = validSoftPullSortOptions.includes(sortBy);
  const isFinanceLoaded = !shouldAwaitCreditStatus || isCreditStatusLoaded;

  return useMemo(
    () => !isLoggedIn || (isFinanceLoaded && isTradeLoaded),
    [isFinanceLoaded, isTradeLoaded, isLoggedIn]
  );
}
